
export default function ButtonSecondary({
  text,
  onClick,
  width,
  padding,
  borderColor,
  bgColor,
  color,
  customClass,
  fontsize,
  iconType,
  disabled,
}) {
  const getIconSrc = () => {
    if (iconType === 'google') {
      return `${process.env.PUBLIC_URL}/Google.svg`;
    }
    if (iconType === 'apple') {
      return `${process.env.PUBLIC_URL}/Apple.svg`;
    }
    return null;
  };

  const iconSrc = getIconSrc();
  const borderClass = borderColor ? `border ${borderColor}` : '';

  return (
    <button
      className={`flex items-center gap-3 ${customClass || ''} ${borderClass} ${width} rounded-md ${bgColor || ''} ${color || ''} ${padding || ''}`}
      onClick={onClick}
      disabled={disabled}
    >
      {iconSrc && (
        <img src={iconSrc} alt={iconType} className="w-5 h-5" />
      )}
      <p className={`${fontsize || ''} ${iconSrc ? '' : 'text-center'} items-center`}>{text}</p>
    </button>
  );
}
